"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Profiles_1 = __importDefault(require("./Profiles"));
exports.default = Profiles_1.default;
